import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/ListaVenta`

export function buscarListaPorVendedor(idVendedor) {
  return http.get(`${API_ENDPOINT}/BuscarPorVendedor/${idVendedor}`)
}

export function insertarLista(listaVenta) {
  return http.post(API_ENDPOINT, listaVenta)
}

export function actualizar(listaModificada) {
  return http.put(API_ENDPOINT, listaModificada)
}
